module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN323_655723893.ee0c8b93.png";